import { createContext, useEffect, useState } from "react";


export const authContext = createContext();
const user_data = "censo";

const AuthProvider = ({ children }) => {

    const [auth, setAuth] = useState(false)
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (sessionStorage.getItem('censo') != null) {
            setAuth(true)
            setIsLoading(false);
        }
    }, [])

    const logout = () => {
        sessionStorage.removeItem(user_data);
    };


    return (
        <authContext.Provider value={{ logout, auth, setAuth, isLoading }}>
            {children}
        </authContext.Provider>
    )
}
export default AuthProvider